'use client';

import { clsx } from 'clsx';
import { FC, PropsWithChildren, RefObject, useEffect, useRef } from 'react';
import { DivRef } from 'pages/ProductListing/types';
import styles from './ProductGrid.module.css';

const observeIntersection = (
  refObject: RefObject<DivRef>,
  callback?: () => void,
) => {
  if (typeof window === 'undefined' || !window.IntersectionObserver) {
    return null; // not to break tests
  }

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting && callback) {
      callback();
    }
  });

  if (refObject.current) {
    observer.observe(refObject.current as Element);
  }

  return observer;
};

export const InView: FC<
  PropsWithChildren<{
    enable: boolean;
    onVisible: () => void;
    className?: string;
  }>
> = ({ children, enable, onVisible, className }) => {
  const refObject = useRef(null);

  useEffect(() => {
    observeIntersection(refObject, onVisible);
  }, [enable]);

  return enable ? (
    <div className={clsx(styles.inView, className)} ref={refObject}>
      {children}
    </div>
  ) : (
    children
  );
};
